module.exports = __webpack_public_path__ + "public/img/品牌介绍_EN.3b504fb7.png";